import { apiClient } from "@base/api/client";
import type { ReservationsResponse } from "@features/reservation/model/types";

/**
 * GET /82office/resource/api/meeting/reserve?year=&month=
 * 미팅룸 예약 목록 조회 (myinfo 탭에서 사용 시 이 파일 사용, reservation feature의 reserve.ts와 동일)
 */
export async function fetchReservations(year: number, month: number): Promise<ReservationsResponse> {
  const { data } = await apiClient.get<ReservationsResponse>("/82office/resource/api/meeting/reserve", {
    params: { year, month },
  });
  return data;
}

interface HasPastReservationResponse {
  has_past_reservation: boolean;
}

/**
 * GET /82office/resource/api/meeting/has-past-reservation
 * 현재까지 예약한 미팅룸 이력이 있는지 여부 조회 (인증된 본인 이력만 반환됨)
 */
export async function fetchHasPastReservation(): Promise<boolean> {
  const { data } = await apiClient.get<HasPastReservationResponse>(
    "/82office/resource/api/meeting/has-past-reservation",
  );
  return data.has_past_reservation;
}

/*
 * TanStack Query 사용 예시:
 * import { useQuery } from "@tanstack/react-query";
 * const { data } = useQuery({
 *   queryKey: ["reservations", year, month],
 *   queryFn: () => fetchReservations(year, month),
 * });
 */
